import React, { useState } from 'react'

import { Button } from '@smarty-nx/ds'

import { ActionType, content } from './group-landing-page-cta.content'
import classes from './group-landing-page-cta.module.scss'
import {
  GroupLandingCTAType,
  GroupLandingPageCTAProps,
} from './group-landing-page-cta.types'
import { useGetUserType } from '../../../hooks'
import { GroupPlanModal } from '../group-plan-modal'

export const GroupLandingPageCTA = ({
  buttonType,
  dataTestIdPrefix,
}: GroupLandingPageCTAProps) => {
  const userType = useGetUserType()
  const [showModal, setShowModal] = useState<boolean>(false)

  const openModal = () => setShowModal(true)
  const closeModal = () => setShowModal(false)

  const userContent = content[buttonType].actions[userType]

  return (
    <div className={classes.ctaWrapper}>
      <Button
        className={classes.groupLandingCta}
        data-testid={`${content[buttonType].testId}${
          dataTestIdPrefix ? `-${dataTestIdPrefix}` : ''
        }`}
        data-item-category="NV"
        data-item-name={
          buttonType === GroupLandingCTAType.EVERYONE_UNLIMITED
            ? 'get-everyone-unlimited'
            : 'get-mix-and-match'
        }
        as={(linkProps) =>
          userContent.actionType === ActionType.Link ? (
            <a
              {...linkProps}
              onClick={() => {
                window.open(userContent.url, '_blank', 'noopener noreferrer')
              }}
            >
              {content[buttonType].caption}
            </a>
          ) : (
            <a {...linkProps} onClick={openModal}>
              {content[buttonType].caption}
            </a>
          )
        }
      />
      {userContent.actionType === ActionType.ErrorModal && (
        <GroupPlanModal
          showModal={showModal}
          onHideModal={closeModal}
          modalType={userContent.modalType}
        />
      )}
    </div>
  )
}
